'use strict'

module.exports = process
